<template>
  <v-app :dark="isDark">
    <v-navigation-drawer
      fixed
      temporary
      :clipped="$vuetify.breakpoint.mdAndUp"
      app
      v-model="drawer"
    >
        <v-layout column fill-height>
      <v-list dense>
        <template v-for="item in items">
          <v-list-group
            v-if="item.children"
            v-show="item.children.length>0"
            v-model="item.model"
            :key="item.text"
            :prepend-icon="item['icon-alt']"
            append-icon="item['icon-alt']"
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.text|translate}}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-for="(child, i) in item.children"
              :key="i"
              @click="jumpToLink(child.to)"
              style="text-indent:30px"
            >
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ child.text|translate}}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else-if="item.href" @click="openInternalHref(item.href)" :key="item.text">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text|translate}}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-else @click="jumpToLink(item.to)" :key="item.text">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text|translate}}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
            <v-spacer></v-spacer>
        <div style="height:50px;">
            <img   class="ml-3" :src="require('@/assets/img/newlogo.png')" height="27"/>
            <span  class="ml-2" style="padding-top: 0">
            powered by <strong>Carnot Innovations</strong>
            </span>
        </div>
        </v-layout>
    </v-navigation-drawer>
    <v-toolbar
      color="primary darken-1 hidden-print-only"
      :class="mobileMode ? 'carnotmobilemainbar' : ''"
      v-if="!hideToolbar"
      dark
      dense
      app
      :clipped-left="$vuetify.breakpoint.mdAndUp"
      fixed
    >
      <v-toolbar-title v-if="!disableMenu&&!mobileMode" :style="'width: 80px'" class="ml-0 pl-3">
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      </v-toolbar-title>
        <v-toolbar-title v-if="!disableMenu&&mobileMode" class="ml-0">
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      </v-toolbar-title>
      <img v-if="brandName=='JEC'" @click="jumpToLink('/')" class="cursor-as-pointer" :src="require('@/assets/img/logojec.jpg')" height="48"/>
      <span v-if="brandName=='JEC'" @click="jumpToLink('/')" class="cursor-as-pointer" style="padding-top: 28px;">
            - {{facilityName}}
        </span>
      <img v-if="brandName=='Carnot Innovations'" @click="jumpToLink('/')" class="cursor-as-pointer" :src="require('@/assets/img/newlogo.png')" height="40"/>
      <img v-if="brandName!='Carnot Innovations'&&brandName!='JEC'&&alternativeLogo" @click="jumpToLink('/')" class="cursor-as-pointer mr-2" :src="'/'+alternativeLogo" height="48"/>
      <span v-if="brandName!='disabled'&&brandName!='JEC'" @click="jumpToLink('/')" class="hidden-sm-and-down cursor-as-pointer" style="padding-top: 0; font-size: 20px;">
            {{ brandName }} &nbsp;- &nbsp;
        </span>
        <span v-if="brandName!='JEC'" @click="jumpToLink('/')" class="cursor-as-pointer" style="padding-top: 0; font-size: 20px;">
            {{facilityName}}
        </span>
      <v-spacer></v-spacer>
        <img v-if="!mobileMode&&secondaryLogo" @click="jumpToLink('/')" class="cursor-as-pointer" :src="'/'+secondaryLogo" height="48"/>
      <v-menu offset-y class="mr-1" v-if="langSelect&&!mobileMode">
        <v-btn flat large slot="activator">
          <v-icon class="mr-2">fa-globe</v-icon> {{langMap[currentLang]}}
        </v-btn>

        <v-list>

          <v-list-tile v-for="lang in languages" v-if="lang.value!==currentLang" @click.prevent="setLang(lang.value)">
            <v-list-tile-title> {{lang.text}} </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
        <v-menu offset-y v-if="langSelect&&mobileMode" >
            <v-btn icon slot="activator">
                <v-icon>fa-globe</v-icon>
            </v-btn>

            <v-list>
                <v-list-tile v-for="lang in languages" v-if="lang.value!==currentLang" @click.prevent="setLang(lang.value)">
                    <v-list-tile-title> {{lang.text}} </v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>
      <v-tooltip bottom v-if="!mobileMode">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="jumpToLink('/')" v-bind="attrs" v-on="on">
            <v-icon>fa-th</v-icon>
          </v-btn>
        </template>
        <span>{{'Overview'|translate}}</span>
      </v-tooltip>
      <v-tooltip bottom v-if="!mobileMode">
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on" >
            <v-badge v-if="!disableNotifications"
              color="accent"
              overlap
            >
              <template v-slot:badge>
                <span>{{notificationCount}}</span>
              </template>
            <v-icon @click="jumpToLink('/notifications')" >fa-bell</v-icon>
            </v-badge>
          </div>
        </template>
        <span>{{'Notifications'|translate}}</span>
      </v-tooltip>
      <v-tooltip bottom v-if="!mobileMode">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="!disableNotifications" icon to="/maintenancerecord" v-bind="attrs" v-on="on">
            <v-icon>fa-notes-medical</v-icon>
          </v-btn>
        </template>
        <span>{{'Maintenance Record'|translate}}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-menu offset-y>
            <v-btn icon large slot="activator" v-bind="attrs" v-on="on">
              <v-avatar size="32px" tile>
                <v-icon>fa-user</v-icon>
              </v-avatar>
            </v-btn>          
            <v-list>
              <v-list-tile><v-list-tile-title>{{'Logged in as'|translate}} {{username}}</v-list-tile-title></v-list-tile>
              <v-list-tile @click="userdialog=true" v-if="!authIsExternal">
                <v-list-tile-title> {{'Account Settings'|translate}} </v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click.prevent="logout">
                <v-list-tile-title> {{'Logout'|translate}} </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </template>
        <span>{{'User Account'|translate}}</span>
      </v-tooltip>
      <user-profile-dialog v-model="userdialog" :item="username" ></user-profile-dialog>
    </v-toolbar>

    <v-content>
      <transition enter-active-class="animated fadeIn"
                  leave-active-class="animated flipOutY"
                  appear
                  mode="out-in">
      <v-container key="1" fluid fill-height v-if="$store.state.pointsListStore.pointsLoaded||forceDisplay" id="carnotMainContent" :class="mobileMode ? 'carnotMainMobileContent' : ''">
        <v-layout justify-center align-start>
          <transition name="slide-fade" mode="out-in">
            <router-view v-if="coreLoaded||forceDisplay"></router-view>
          </transition>
        </v-layout>
      </v-container>
      <v-container key="2" fluid fill-height v-else>
        <v-layout justify-center align-center>
          {{'Loading Points List'|translate}} <v-progress-circular class="ml-3" color="primary" indeterminate></v-progress-circular>
        </v-layout>
      </v-container>
      </transition>


    </v-content>
    <v-toolbar v-if="hideToolbar">
      <v-btn outline class="secondary" to="/notifications">{{'Notification'|translate}}</v-btn>
      <v-btn outline class="secondary" to="/modelsummary">{{'Machine Learning Fault Detection'|translate}}</v-btn>
      <v-btn outline class="secondary" to="/controllogic">{{'Control Logic Benefit'|translate}}</v-btn>
      <v-btn outline class="secondary" to="/multiplots">{{'Time Series Plot'|translate}}</v-btn>
      <v-btn outline class="secondary" to="/maintenancerecord">{{'Maintenance Record'|translate}}</v-btn>
      <v-btn outline class="secondary" to="/energyefficiency">{{'COP'|translate}}</v-btn>
      <v-btn outline class="secondary" to="/load">{{'Cooling Load'|translate}}</v-btn>
      <v-spacer></v-spacer>
      <v-btn flat @click="drawer=!drawer">   </v-btn>
    </v-toolbar>

    <global-snackbar></global-snackbar>

  </v-app>
</template>


<script>

import GlobalSnackbar from './components/GlobalSnackbar'
import UserProfileDialog from "./components/users/UserProfileDialog";
import { jwtDecode,getCurrentUser} from './helper'
import { mapGetters } from 'vuex'
import { msalMixin } from "vue-msal";
import axios from "axios";
export default {
  name: 'App',
  mixins: [msalMixin],
  components: { GlobalSnackbar,UserProfileDialog},
  data: () => ({
    openfault: true,
    langSelect:false,
    currentLang:"en",
    coreLoaded:false,
    languages:[],
    langMap:{},
    forceDisplay:false,
      dialog: false,
      userdialog: false,
      drawer: false,

    }),
    props: {
    },
  methods: {
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    setLang(lang){
      this.currentLang=lang
      localStorage.setItem('currentLang', lang)
      setTimeout(function (){window.location.reload()},500)
    },
    jumpToLink (payload) {
      if((payload==="/"||payload==="/overview")&&this.items&&this.items.filter(x=>x.to)[0]&&this.items.filter(x=>x.to)[0].to!=="/overview"){
        this.$router.push(this.items.filter(x=>x.to)[0].to)
      } else {
        this.$router.push(payload)
      }
    },
    openInternalHref(href){
      let pass = localStorage.getItem('pass');
      window.location.href=process.env.VUE_APP_EXTERNAL_AUTH&&process.env.VUE_APP_EXTERNAL_AUTH==="msal" ? href : href+'?token='+pass;
    },
    logout () {
      if (process.env.VUE_APP_EXTERNAL_AUTH&&process.env.VUE_APP_EXTERNAL_AUTH==="msal"){
        this.$msal.signOut()
      } else {
        localStorage.setItem('pass', '') //reset token in localstorage
        window.location.href="/login";
      }
    },
    sendToLogin(){
      this.$router.push({
        name: 'login',
        query: {
          wantedRoute: this.$router.currentRoute.fullPath
        },
      });
      this.forceDisplay=true;
    },
    async initCore(){
      await this.$store.dispatch('refreshFacilityList')
      await this.$store.dispatch('refreshPointsList', null)
      await this.$store.dispatch('refreshUserPlots')
      await this.$store.dispatch('refreshPublishedCustomViews')
      if(!this.disableNotifications){
          try {
              await this.$store.dispatch('refreshNotification',
                  {'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                      'ignore_acknowledged': true
                  })
          }
          catch(err) {
              console.log("notifications are broken")
          }
      }
      if((this.$router.currentRoute.path==="/"||this.$router.currentRoute.path==="/overview")&&this.items&&this.items.filter(x=>x.to)[0]&&this.items.filter(x=>x.to)[0].to!=="/overview"){
        await this.$router.push(this.items.filter(x=>x.to)[0].to)
      }
      this.coreLoaded=true
    },
  },
  watch: {
    '$route.name': {
      handler: function(item) {
        if(item==="login"){
          this.forceDisplay=true;
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapGetters([
      'userPlots','publishedCustomViews','menuConfig','mobileMenuConfig','hideFddToolbar'
    ]),
    brandName(){
      if (localStorage.getItem('brandingOverride')== '1'){
        return "Carnot Innovations"
      }
      return process.env.VUE_APP_BRAND_NAME ? process.env.VUE_APP_BRAND_NAME : "Carnot Innovations"
    },
    disableMenu(){
      return process.env.VUE_APP_DISABLE_MENU ? process.env.VUE_APP_DISABLE_MENU : false
    },
      alternativeLogo(){
          return process.env.VUE_APP_ALTERNATIVE_LOGO ? process.env.VUE_APP_ALTERNATIVE_LOGO : null
      },
      secondaryLogo(){
          return process.env.VUE_APP_SECONDARY_LOGO ? process.env.VUE_APP_SECONDARY_LOGO : null
      },
    mobileMode(){
          return process.env.VUE_APP_MOBILE_MODE ? process.env.VUE_APP_MOBILE_MODE : false
      },
    disableNotifications(){
      if (this.hideFddToolbar){
        return true
      }
      return process.env.VUE_APP_DISABLE_NOTIFICATIONS ? process.env.VUE_APP_DISABLE_NOTIFICATIONS : false
    },
    isDark(){
      return process.env.VUE_APP_THEME=='dark'
    },
    facilityName(){
        let name = this.$store.state.pointsListStore.pointsList.facility_name;
        for (let facility of this.$store.state.facilityStore.facilityList) {
            if (facility.facility_name === name) {
                if (facility.description&&facility.description!==""){
                    return facility.description
                }
                break
            }
        }
        return name;
    },
    hideToolbar () {
      return process.env.VUE_APP_HIDE_TOOLBAR=='yes'
    },
    username () {
      if (this.$store.state.userStore.user) {
        return this.$store.state.userStore.user.content.user_name
      }
      return null;
    },
    notificationCount () {
      return this.$store.getters.importantNotificationsCount
    },
    authIsExternal () {
      return process.env.VUE_APP_EXTERNAL_AUTH&&process.env.VUE_APP_EXTERNAL_AUTH!==""
    },
    items () {
      return _.filter(this.rawItems, (x) => {
        return !(_.get(x, 'disabled', false))
      })
    },
    rawItems () {
      let allItems=[]
      if (process.env.VUE_APP_MOBILE_MODE&&this.mobileMenuConfig){
        allItems=JSON.parse(JSON.stringify(this.mobileMenuConfig))
      } else if (this.menuConfig){
        allItems=JSON.parse(JSON.stringify(this.menuConfig))
      } else if(process.env.VUE_APP_MENU_CONFIG&&process.env.VUE_APP_MENU_CONFIG!==""){
        allItems=require('./config/menu/'+process.env.VUE_APP_MENU_CONFIG+".js").default()
      } else {
        allItems=require('./config/menu/generic.js').default()
      }
      let me=this
      if (!process.env.VUE_APP_MOBILE_MODE&&this.publishedCustomViews) {
        let filtered = this.publishedCustomViews.filter(x => x.facility === me.$store.state.pointsListStore.pointsList.facility_name)
        for (let userPlot of filtered) {
          let itemTo="/custom-view/" + userPlot.id
          let foundOccurences=allItems.filter(x=>x.to===itemTo||(x.children&&x.children.filter(y=>y.to===itemTo).length>0))
          if(foundOccurences.length>0){
            continue
          }
          let itemEntry = {'text': userPlot.linkTitle, 'to': itemTo};
          if (userPlot.icon) {
            itemEntry.icon = userPlot.icon
          }
          let menuName = 'Custom Views'
          let found = false;
          for (let item of allItems) {
            if (item.children && item.text === menuName) {
              item.children.push(itemEntry)
              found = true;
              break;
            }
          }
          if (!found) {
            allItems.push({
              icon: 'fa-angle-up',
              'icon-alt': 'fa-angle-down',
              text: menuName,
              model: false,
              children: [itemEntry]
            });
          }
        }
      }
      if(!process.env.VUE_APP_MOBILE_MODE&&this.$store.state.userStore.user&&this.userPlots){
        let filtered=this.userPlots.filter(x=>x.facility===me.$store.state.pointsListStore.pointsList.facility_name&&x.user_id===me.$store.state.userStore.user.content.sub)
        if(filtered.length>0){
          allItems.push({
            icon: 'fa-angle-up',
            'icon-alt': 'fa-angle-down',
            text: 'User',
            model: false,
            children: filtered.map(function(userPlot){
              return {'text':userPlot.linkTitle,'to':"/user-automated/"+userPlot.id}
            })
          });
        }
      }
      if(!process.env.VUE_APP_MOBILE_MODE&&this.$store.state.userStore.user&&this.$store.state.userStore.user.content.role&&this.$store.state.userStore.user.content.role!=="viewer") {
          let configFeatures = [
              {icon: 'fa-tools', text: 'Equipments', to: '/equipments'},
              {icon: 'fa-building', text: 'Facilities', to: '/facility'},
              {icon: 'fa-broadcast-tower', text: 'Points', to: '/points'},
              {icon: 'fa-cog', text: 'Builder', to: '/builder'},
              {icon: 'fa-sitemap', text: 'Equipment Relationships', to: '/equipment-relationships'},
              {icon: 'fa-cog', text: 'Point Mapper', to: '/point-mapper'},
              {icon: 'fa-network-wired', text: 'Connectors', to: '/connectors'},
              {icon: 'fa-code', text: 'Scripts', to: '/scripts'},
              {icon: 'fa-cog', text: 'Optimization Controls', to: '/optimization-controls'},
              {icon: 'fa-cube', text: 'Graphics', to: '/graphics'},
              {icon: 'fa-bell', text: 'Anomaly Descriptions', to: '/anomaly-description'},
              {icon: 'fa-cog', text: 'Config', to: '/config'},
              {icon: 'fa-ruler-horizontal', text: 'Parameter', to: '/parameter'},
              {icon: 'fa-sliders-h', text: 'Settings', to: '/settings'},
              {icon: 'fa-mail-bulk', text: 'Report', to: '/report'},
              {icon: 'fa-align-justify', text: 'Rules', to: '/rules'},
              {icon: 'fa-download', text: 'Export Data', to: '/viewdata'},
              {icon: 'fa-chart-bar', text: 'Custom Views', to: '/custom-views'},
              {icon: 'fa-calendar-alt', text: 'Dates', to: '/dates'},
              {icon: 'fa-tools', text: 'Equipment Servicing Schedule', to: '/equipment-servicing-schedule'},
              {icon: 'fa-bars', text: 'Menu items', to: '/menu-config'},
              {icon: 'fa-users', text: 'Users', to: '/users'},
          ]
          if (process.env.VUE_APP_DISABLED_FEATURES && process.env.VUE_APP_DISABLED_FEATURES !== "") {
              let disabledFeatures = process.env.VUE_APP_DISABLED_FEATURES.split(",")
              configFeatures = configFeatures.filter(x => disabledFeatures.indexOf(x.text) < 0)
          }
          if (this.$store.state.userStore.user.content.role!=="admin"){
              configFeatures=configFeatures.filter(x=>x.to!=="/optimization-controls")
          }
          allItems.push({
              icon: 'fa-angle-up',
              'icon-alt': 'fa-angle-down',
              text: 'Config',
              model: false,
              children: configFeatures
          })
      }
      allItems.push({icon: 'fa-question', text: 'Terms of Service', to: '/help'})
      for (let item of allItems){
        if(item.facilityFilter&&item.facilityFilter!==""&&item.facilityFilter!==me.$store.state.pointsListStore.pointsList.facility_name){
          item.disabled=true
        } else if (item.facilityExceptFilter&&item.facilityExceptFilter===me.$store.state.pointsListStore.pointsList.facility_name){
          item.disabled=true
        } else if (item.to&&item.to.startsWith("/custom-view/")){
            let idOfItem=item.to.substring(13)
            if (this.publishedCustomViews.filter(x=>x.id===idOfItem).length===0){
              item.disabled=true
            }
        }
        if(item.children){
          for (let child of item.children){
            if(child.facilityFilter&&child.facilityFilter!==""&&child.facilityFilter!==me.$store.state.pointsListStore.pointsList.facility_name){
              child.toRemove=1
            } else if(child.facilityExceptFilter&&child.facilityExceptFilter===me.$store.state.pointsListStore.pointsList.facility_name){
              child.toRemove=1
            } else if (child.to&&child.to.startsWith("/custom-view/")){
              let idOfChild=child.to.substring(13)
              if (this.publishedCustomViews.filter(x=>x.id===idOfChild).length===0){
                child.toRemove=1
              }
            }
          }
          item.children=item.children.filter(x=>!x.toRemove)
        }
      }
      return allItems;
    }

  },
  async mounted () {
      if (process.env.VUE_APP_AUTOMATED_API_ROUTING&&process.env.VUE_APP_AUTOMATED_API_ROUTING_SUFFIX&&process.env.VUE_APP_AUTOMATED_API_ROUTING_PREFIX){
          await this.$store.dispatch('setURLOverride', process.env.VUE_APP_AUTOMATED_API_ROUTING_PREFIX+window.location.host.split(".")[0]+process.env.VUE_APP_AUTOMATED_API_ROUTING_SUFFIX)
      } else {
          let configOverride = null;
          try {
              configOverride = await axios.get('/config.json');
          } catch (err) {
              console.log("No config override found")
          } finally {
              if (configOverride&&configOverride.data){
                  let overrideConf=configOverride.data
                  if ((typeof overrideConf === 'string' || overrideConf instanceof String)&&overrideConf.startsWith("{")){
                      overrideConf=JSON.parse(overrideConf)
                  }
                  if(overrideConf[window.location.host]&&overrideConf[window.location.host].API_BASE_URL){
                      await this.$store.dispatch('setURLOverride', overrideConf[window.location.host].API_BASE_URL)
                  } else if(overrideConf["*"]&&overrideConf["*"].API_BASE_URL){
                      await this.$store.dispatch('setURLOverride', overrideConf["*"].API_BASE_URL)
                  }
              }
          }
      }
    if(process.env.VUE_APP_PAGE_TITLE&&process.env.VUE_APP_PAGE_TITLE!=""){
      document.title=process.env.VUE_APP_PAGE_TITLE
    } else {
      document.title="Carnot Innovations Dashboard"
    }
    if(process.env.VUE_APP_INTERFACE_TRANSLATION){
      let translator = require('./translator.js').default
      this.currentLang=translator.currentLang
      this.languages=translator.languages
      let newLangMap={}
      for(let lang of translator.languages){
        newLangMap[lang.value]=lang.text
      }
      this.langMap=newLangMap
      this.langSelect=true
    }

    if (process.env.VUE_APP_EXTERNAL_AUTH&&process.env.VUE_APP_EXTERNAL_AUTH==="msal"){
      await this.sleep(1000)
      if (this.$msal.isAuthenticated()) {
        await this.sleep(800)
        let token = null
        if (this.$msal.data&&this.$msal.data.accessToken){
            token=this.$msal.data
        }  else {
            token= await this.$msal.acquireToken()
            await this.sleep(500)
        }
        if(!token||!token.accessToken){
          if (this.$router.currentRoute.name === "login") {
            this.forceDisplay = true;
          } else {
            this.sendToLogin()
          }
        } else {
          let cuRec=await getCurrentUser()
          await this.$store.dispatch('setUser', {token: token, content: cuRec.user})
          await this.initCore()
        }
      } else if (this.$router.currentRoute.name === "login") {
        this.forceDisplay = true;
      } else {
        this.sendToLogin()
      }
    } else {
      let token = localStorage.getItem('pass')
      if(token&&token!==""){
        let content=null;
        try {
          content = jwtDecode(token)
        }
        catch(err) {
          localStorage.setItem('pass', null)
          this.sendToLogin()
        }
        if(content){
          await this.$store.dispatch('setUser', {token: token, content: content})
          await this.initCore()
        }
      } else if (process.env.VUE_APP_LOGIN!='yes') {
        await this.initCore()
      } else if(this.$router.currentRoute.name=="login"){
        this.forceDisplay=true;
      } else {
        this.sendToLogin()
      }
    }


  }
}

</script>

<style scoped>
.carnotMainMobileContent {
 padding-left: 0 !important;
 padding-right: 0 !important;
}
 .slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(30px);
  opacity: 0;
}
</style>

<style>
.carnotmobilemainbar > div.v-toolbar__content{
    padding-left: 0 !important;
    padding-right: 0 !important;
}
  .cursor-as-pointer{
    cursor: pointer;
  }
  .v-input__control>.v-input__slot input {
    caret-color: auto;
  }
  .v-input__control>.v-input__slot textarea {
    caret-color: auto;
  }
  .v-card__title{
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }
  .v-card__title .v-input{
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .v-card__title button{
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  div>label.primary--text {
    color:#9b9b9b !important;
  }

  i.fa-times-circle {
    color:#9b9b9b !important;
  }

  a.v-list__tile--active{
    color:#9b9b9b !important;
  }

  .v-dialog {
    background-color:#424242;
  }

</style>
